import { actions } from './actions';
import { SiteListState, state } from './state';
import { mutations } from './mutations';
import { getters } from './site-list-getters';

const SiteListModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
export default SiteListModule;
export type { SiteListState };
